import React from 'react'
import GoogleMapReact from 'google-map-react'
import { APIKey as GoogleAPIKey } from '../../utils/google'
import { colors } from '../../styleConstants'
import styled from 'styled-components'
import { Button } from './Button'

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  readonly center: { lat: number; lng: number }
  readonly language: string
  readonly zoom: number
  readonly text: string
  readonly buttonText?: string
}

const AnyReactComponent = styled.div<{
  lat: number
  lng: number
}>`
  width: 96px;
`

const Marker = styled.img`
  width: 24px;
  height: 42px;
  position: relative;
  top: -42px;
  left: -24px;
`

const MarkerText = styled.span`
  position: relative;
  top: -84px;
  left: 6px;
  font-weight: bold;
  font-size: 1em;
  color: ${colors.primary};
  display: block;
`

const MobileOnly = styled.div`
  @media screen and (min-width: 480px) {
    display: none;
  }
`

export class GoogleMap extends React.Component<Props> {
  private APIKey: string = GoogleAPIKey
  static defaultProps = {
    center: {
      lat: 35.681236,
      lng: 139.767125,
    },
    zoom: 18,
  }

  private mapOptions = {
    styles: [
      {
        featureType: 'all',
        elementType: 'all',
        stylers: [
          {
            visibility: 'on',
          },
        ],
      },
    ],
  }

  render() {
    return (
      <>
        {this.props.buttonText && (
          <MobileOnly>
            <Button
              look="primary"
              bordered
              onClick={() =>
                (location.href = `https://maps.apple.com./?q=${this.props.center.lat},${this.props.center.lng}`)
              }
              style={{ display: 'block', margin: '0px auto 10px', width: '260px' }}>
              {this.props.buttonText}
            </Button>
          </MobileOnly>
        )}
        <div style={{ height: '50vh', width: '100%' }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: this.APIKey, language: this.props.language }}
            defaultCenter={this.props.center}
            defaultZoom={this.props.zoom}
            options={this.mapOptions}>
            <AnyReactComponent lat={this.props.center.lat} lng={this.props.center.lng}>
              <Marker src="/static/google-map-marker.png" />
              <MarkerText>{this.props.text}</MarkerText>
            </AnyReactComponent>
          </GoogleMapReact>
        </div>
      </>
    )
  }
}
